import { render, staticRenderFns } from "./SsrSelection.vue?vue&type=template&id=a3d6238a&scoped=true"
import script from "./SsrSelection.vue?vue&type=script&lang=js"
export * from "./SsrSelection.vue?vue&type=script&lang=js"
import style0 from "./SsrSelection.vue?vue&type=style&index=0&id=a3d6238a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d6238a",
  null
  
)

export default component.exports